import { BaseEntity } from '@/api/EntityApi';
import { DeepKeys } from '@tanstack/react-table';
import LANGUAGES from '@/configs/languages';

export type Language = keyof typeof LANGUAGES;
export type ForeignLanguage = Exclude<Language, 'PL'>;
export type Translations<TData> = Record<ForeignLanguage, TData>;

export type SortOrder = 'ASC' | 'DESC';

export interface Sort<TData extends BaseEntity = any> {
	key: DeepKeys<TData> | null;
	order: SortOrder;
}

export interface ApiQueryOptions<TData extends BaseEntity> {
	page: number;
	limit: number;
	search: string;
	sortBy: Sort<TData>;
}

export type CustomFilters = Record<string, unknown>;

export interface ApiPaginatedResponse<TData extends {} = {}> {
	data: TData[];
	meta: {
		currentPage: number;
		itemsPerPage: number;
		totalItems: number;
		totalPages: number;
	};
}

export interface ApiFormattedResponseData<TData extends {} = {}> {
	data: TData[];
	totalPages: number;
}

export interface CreateManyResponse {
	passed: string[];
	rejected: string[];
}

export interface Attachment {
	id: UUID;
	path: string;
	name: string;
	size: number;
	mimetype: string;
}

export type UUID = ReturnType<typeof crypto.randomUUID>;

export enum RelationType {
	ATTRIBUTE_VALUE = 'ATTRIBUTE_VALUE',
}

export enum RelationAction {
	HIDE = 'HIDE',
	SHOW = 'SHOW',
}

export interface Relation {
	type: RelationType;
	objectId: UUID | '';
	action: RelationAction;
}
